export default "__VITE_ASSET__DDYaai6M__"